import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Switch,
  Button,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Stack,
  Skeleton,
  useMediaQuery,
  useTheme,
  Divider,
  alpha,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { showToast, WEBSERVICE } from "../../../CoreDataService";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import AddIcon from "@mui/icons-material/Add";
import dayjs from "dayjs";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { useSelector } from "react-redux";
import { ContainedButton, OutlinedButton } from "../../../Common/Buttons";

const PortfolioWallet = () => {
  const { btncolor, allColors } = useSelector((state) => state);
  const themeColor = localStorage.getItem("theme") || "dark";
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [portfolioInvestmentPlans, setPortfolioInvestmentPlans] = useState([]);
  const [homeCurrency, setHomeCurrency] = useState(
    localStorage.getItem("homeCurrency")
  );
  const [marketPrice, setMarketPrice] = useState(0);
  const [homeCurrencySymbol, seHomeCurrencySymbol] = useState(
    localStorage.getItem("homeCurrencySymbol")
  );
  const [investedAssetList, setInvestedAssetList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [isRemoveDialogOpen, setIsRemoveDialogOpen] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);

  const [tabIndex, setTabIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const accessToken = localStorage.getItem("access_token");
  const uuid = localStorage.getItem("uuid");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [assets, setAssets] = useState([{ index: 0 }]);
  const [selectedRecurringPeriodId, setSelectedRecurringPeriodId] =
    useState("");
  const [daysSelected, setDaysSelected] = useState([]);
  const [localTimeHour, setLocalTimeHour] = useState("");
  const [localTimeMin, setLocalTimeMin] = useState("");

  const [recurringPeriodsOther, setRecurringPeriodsOther] = useState([]);
  const [recurringPeriodsHours, setRecurringPeriodsHours] = useState([]);

  const [portfolioAssets, setPortfolioAssets] = useState([]);
  const [portfolioAssetsForBase, setPortfolioAssetsForBase] = useState([]);
  const [portfolioAssetsForCounter, setPortfolioAssetsForCounter] = useState(
    []
  );

  const [earnWalletBalance, setEarnWalletBalance] = useState(0);
  const [spotWalletBalance, setSpotWalletBalance] = useState(0);

  const [planNameForCreate, setPlanNameForCreate] = useState("");
  const [addAssetList, setAddAssetList] = useState([
    { index: 0, asset: "", percent: "" },
  ]);
  const [currentSumOfAllocation, setCurrentSumOfAllocation] = useState(0);
  const [recurringAmount, setRecurringAmount] = useState("");
  const [recurringAssetId, setRecurringAssetId] = useState("");
  const [isEarnWalletSelected, setIsEarnWalletSelected] = useState(false);
  const [isOneTimeEnable, setIsOneTimeEnable] = useState(false);
  const [daysOfWeeks] = useState([
    "MON",
    "TUE",
    "WED",
    "THU",
    "FRI",
    "SAT",
    "SUN",
  ]);
  const [selectedDays, setSelectedDays] = useState([]);
  const [dateOfMonth, setDateOfMonth] = useState("");
  const [localTime, setLocalTime] = useState("");
  const [selectedRecurringPeriodName, setSelectedRecurringPeriodName] =
    useState("");
  const [portfolioRecurringPeriods, setPortfolioRecurringPeriods] = useState(
    []
  );
  const [masterInvestmentId, setMasterInvestmentId] = useState("");
  const [invCurrencyId, setInvCurrencyId] = useState("");

  const handleShowInvestment = async (planId) => {
    setSelectedPlanId(planId);
    try {
      const payload = {
        investment: {
          userUuid: localStorage.getItem("uuid"),
          id: planId,
        },
      };
      const response = await axios.post(
        WEBSERVICE + "/crypto/banking/portfolio/getPortfolioInvestmentWallet",
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.error?.error_data !== 0) {
        showToast("error", response.data.error?.error_msg);
      } else {
        setInvestedAssetList(response.data.portfolioWalletDetails);
        setShowModal(true);
      }
    } catch (err) {}
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setInvestedAssetList([]);
    setInvCurrencyId("");
  };

  console.log("isOneTimeEnable", isOneTimeEnable);

  const refreshPlans = () => {
    fetchPlans();
  };

  useEffect(() => {
    fetchPlans();
    getAllRecurringPeriod();
    getAllAvailablePortfolioAssets();
    getMarketPrice();
  }, []);

  const getAllAvailablePortfolioAssets = async () => {
    const payload = {
      userUuid: localStorage.getItem("uuid"),
    };
    try {
      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/portfolio/getPortfolioInvestmentAssets`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );
      const result = response.data;
      if (result.error.error_data !== 0) {
        document.body.classList.remove("overlay");
        showToast("error", result.error.error_msg);
      } else {
        const assets = result.portfolioAssets || [];
        const counterAssets = assets.filter((a) => a.isBaseCurrency === 0);
        const baseAssets = assets.filter((a) => a.isBaseCurrency === 1);
        setPortfolioAssets(assets);
        setPortfolioAssetsForCounter(counterAssets);
        setPortfolioAssetsForBase(baseAssets);
      }
    } catch (error) {
      document.body.classList.remove("overlay");
      if ([400, 401, 403].includes(error?.response?.status)) {
        alert("SESSION TIMED OUT. LOGIN AGAIN");
      } else {
        alert("Could Not Connect To Server");
      }
    }
  };

  const fetchPlans = async () => {
    setLoading(true);
    const payload = {
      userUuid: localStorage.getItem("uuid"),
      pageNo: "1",
      pageSize: "100",
    };
    try {
      const { data } = await axios.post(
        WEBSERVICE + "/crypto/banking/portfolio/getPortfolioInvestmentWallets",
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );
      if (data.error.error_data !== 0) {
        setLoading(false);
        alert(data.error.error_msg);
      } else {
        setLoading(false);
        setPortfolioInvestmentPlans(data.portfolioWallets || []);
      }
    } catch (err) {
      setLoading(false);
      if ([400, 401, 403].includes(err.response?.status)) {
        alert("SESSION TIMED OUT. LOGIN AGAIN");
      } else {
        alert("Could Not Connect To Server");
      }
    }
  };

  const updateAutoSubscribe = async (plan, status) => {
    if (status == false) {
      status = 0;
    } else {
      status = 1;
    }
    const payload = {
      investment: {
        userUuid: localStorage.getItem("uuid"),
        id: plan.planId,
        isSubscription: status,
      },
    };
    try {
      const response = await axios.post(
        WEBSERVICE +
          "/crypto/banking/portfolio/updatePortfolioInvestmentStatus",
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );
      const result = response.data;
      if (result.error?.error_data !== 0) {
        showToast("error", result.error?.error_msg || "Something went wrong");
      } else {
        showToast("success", result.error?.error_msg || "Updated successfully");
        fetchPlans();
      }
    } catch (err) {
      if ([401, 400, 403].includes(err?.response?.status)) {
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };

  const openRemoveDialog = (planId) => {
    setSelectedPlanId(planId);
    setIsRemoveDialogOpen(true);
  };

  const openEditDialog = (planId) => {
    setSelectedPlanId(planId);
    setIsEditDialogOpen(true);
  };

  const removePlan = async () => {
    const payload = {
      investment: {
        userUuid: localStorage.getItem("uuid"),
        id: selectedPlanId,
      },
    };
    try {
      const response = await axios.post(
        WEBSERVICE +
          "/crypto/banking/portfolio/removePortfolioInvestmentWallet",
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );
      const result = response.data;
      if (result.error?.error_data !== 0) {
        showToast("error", result.error?.error_msg || "Failed to remove plan");
      } else {
        showToast(
          "success",
          result.error?.error_msg || "Plan removed successfully"
        );
        refreshPlans();
        setIsRemoveDialogOpen(false);
      }
    } catch (err) {
      if ([401, 400, 403].includes(err?.response?.status)) {
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };

  const getWalletBalance = async (val) => {
    setRecurringAssetId(val);
    setLoading(true);
    if (val) {
      const payload = {
        userUuid: localStorage.getItem("uuid"),
        invCurrencyId: val,
      };
      try {
        const response = await axios.post(
          `${WEBSERVICE}crypto/banking/portfolio/getWalletDetailsByUser`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              authorization: `BEARER ${localStorage.getItem("access_token")}`,
            },
          }
        );
        const result = response.data;
        if (result.error?.error_data !== 0) {
          showToast("error", result.error.error_msg);
        } else {
          setEarnWalletBalance(result.earnWalletBalance);
          setSpotWalletBalance(result.spotWalletBalance);
        }
      } catch (error) {
        if ([400, 401, 403].includes(error.response?.status)) {
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        } else {
          showToast("error", "Could Not Connect To Server");
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const getSelectedPeriodName = () => {
    const allPeriods = [...recurringPeriodsOther, ...recurringPeriodsHours];
    const selected = allPeriods.find((p) => p.id === selectedRecurringPeriodId);
    console.log("tttstttss", selected);
    return selected?.name?.toLowerCase() || "";
  };

  const selectedPeriodName = getSelectedPeriodName();
  const isWeekly =
    selectedPeriodName.includes("weekly") || selectedPeriodName.includes("bi");
  const isMonthly = selectedPeriodName.includes("month");
  const needsTime =
    selectedPeriodName.includes("hour") ||
    selectedPeriodName.includes("time") ||
    isMonthly;

  const totalAllocation = assets.reduce(
    (sum, asset) => sum + Number(asset.assetAllocation || 0),
    0
  );
  const isValidAllocation = totalAllocation === 100;

  const formatTime = `${String(localTimeHour).padStart(2, "0")}:${String(
    localTimeMin
  ).padStart(2, "0")}`;
  const today = dayjs();
  let firstCycleMessage = "";

  if (["4 hours", "8 hours", "12 hours"].includes(selectedPeriodName)) {
    firstCycleMessage = `Your first auto-invest cycle will begin on at ${formatTime}`;
  } else if (isMonthly) {
    const dateString = today.date(Number(dateOfMonth)).format("YYYY-MM-DD");
    firstCycleMessage = `Your first auto-invest cycle will begin on ${dateString} at ${formatTime}`;
  } else {
    const dateString = today.format("YYYY-MM-DD");
    firstCycleMessage = `Your first auto-invest cycle will begin on ${dateString} at ${formatTime}`;
  }

  const currencySymbols = {
    INR: "₹",
    USD: "$",
    USDT: "$",
    AED: "د.إ",
    EUR: "€",
    SGD: "S$",
  };

  const getShowDetailsCurrency = async (planId) => {
    const userUuid = localStorage.getItem("uuid");
    try {
      const payload = {
        investment: {
          userUuid,
          id: planId,
        },
      };
      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/portfolio/getPortfolioInvestment`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );
      const result = response.data;
      if (result.error?.error_data !== 0) {
        showToast("error", result.error.error_msg);
        return;
      }
      const res = result?.portfolioInvestment;
      setInvCurrencyId(res.invCurrencyId);
    } catch (error) {}
  };

  const getSpecificPlanDetails = async (planId) => {
    setMasterInvestmentId(planId);
    const userUuid = localStorage.getItem("uuid");
    try {
      const payload = {
        investment: {
          userUuid,
          id: planId,
        },
      };
      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/portfolio/getPortfolioInvestment`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );
      const result = response.data;
      if (result.error?.error_data !== 0) {
        showToast("error", result.error.error_msg);
        return;
      }
      setOpen(true);
      const selectedPlan = result.portfolioInvestment;
      setSelectedPlan(selectedPlan);
      setPlanNameForCreate(selectedPlan.planName);
      const assets = selectedPlan.investmentAssets.map((item, index) => ({
        index,
        asset: item.currencyId,
        percent: item.assetAllocation,
        allocationId: item.id,
      }));
      console.log("assets", assets);
      setAddAssetList(assets);
      const totalAllocation = selectedPlan.investmentAssets.reduce(
        (sum, item) => sum + parseInt(item.assetAllocation, 10),
        0
      );
      setCurrentSumOfAllocation(parseFloat(totalAllocation));
      setRecurringAssetId(selectedPlan.invCurrencyId);
      setRecurringAmount(selectedPlan.investmentAmount);
      setIsEarnWalletSelected(selectedPlan.isEarnWallet === 1);
      setIsOneTimeEnable(selectedPlan.isSubscription === 1);
      const [hours, minutes] = selectedPlan.localTime.split(":");
      setLocalTimeHour(hours);
      setLocalTimeMin(minutes);
      const recurringPeriodId = parseInt(selectedPlan.recurringPeriodId);
      console.log("recurringPeriodId", recurringPeriodId);
      setSelectedRecurringPeriodId(recurringPeriodId);
      const periodName =
        getRecurringPeriodNameById(recurringPeriodId)?.name || "";
      setSelectedRecurringPeriodName(periodName);
      console.log("periodName", periodName);
      if (periodName === "Weekly" || periodName === "Bi-weekly") {
        const repeatDays = selectedPlan.repeatsOn?.split(",") || [];
        repeatDays.forEach((day) => selectDaysForPortfolio(day));
      } else if (periodName === "Monthly") {
        setDateOfMonth(selectedPlan.repeatsOn);
      }
      getWalletBalance(selectedPlan.invCurrencyId);
    } catch (error) {
      if ([401, 400, 403].includes(error.response?.status)) {
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
      } else {
        showToast("error", "Could not connect to server");
      }
    }
  };

  const toggleDay = (day) => {
    setDaysSelected((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const handleAddAsset = () => {};

  const handleRemoveAsset = (indexToRemove) => {};

  const handleAssetChange = (index, field, value) => {
    const updated = addAssetList.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    setAddAssetList(updated);
  };

  useEffect(() => {
    const sum = addAssetList.reduce(
      (acc, curr) => acc + parseFloat(curr.percent || 0),
      0
    );
    setCurrentSumOfAllocation(sum);
  }, [addAssetList]);

  const selectDaysForPortfolio = (day) => {
    setSelectedDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
    console.log("day", day);
  };

  const handleLocalTime = (type) => {
    if (type === "hour" && (+localTimeHour < 0 || +localTimeHour > 23)) {
      setLocalTimeHour("");
    }
    if (type === "min" && (+localTimeMin < 0 || +localTimeMin > 59)) {
      setLocalTimeMin("");
    }
  };

  const getCurrencyNameById = (id) => {
    return portfolioAssetsForBase.find((a) => a.currencyId === id) || {};
  };

  const toggleWallet = () => {
    setIsEarnWalletSelected((prev) => !prev);
  };

  const getAllRecurringPeriod = async () => {
    try {
      const response = await axios.get(
        `${WEBSERVICE}crypto/banking/portfolio/getPortfolioRecurringPeriods?uuid=${localStorage.getItem(
          "uuid"
        )}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );
      const result = response.data;
      if (result.error.error_data !== 0) {
        document.body.classList.remove("overlay");
        alert(result.error.error_msg);
      } else {
        const allPeriods = result.portfolioRecurringPeriods || [];
        const hours = [];
        const others = [];
        for (const period of allPeriods) {
          if ((period.name || "").includes("Hour")) {
            others.push(period);
          } else {
            hours.push(period);
          }
        }
        setPortfolioRecurringPeriods(allPeriods);
        setRecurringPeriodsHours(hours);
        setRecurringPeriodsOther(others);
        console.log("hours", hours);
        console.log("others", others);
      }
    } catch (error) {
      document.body.classList.remove("overlay");
      if ([400, 401, 403].includes(error?.response?.status)) {
        alert("SESSION TIMED OUT. LOGIN AGAIN");
      } else {
        alert("Could Not Connect To Server");
      }
    }
  };

  const getRecurringPeriodNameById = (id) => {
    return portfolioRecurringPeriods.find((period) => period.id === id) || {};
  };

  const clickToUpdate = async () => {
    let investment = {
      userUuid: localStorage.getItem("uuid"),
      planName: planNameForCreate,
      invCurrencyId: recurringAssetId,
      investmentAmount: recurringAmount,
      isEarnWallet: isEarnWalletSelected ? 1 : 0,
      isSubscription: isOneTimeEnable ? 1 : 0,
      recurringPeriodId: selectedRecurringPeriodId,
      id: masterInvestmentId,
      localTime: `${localTimeHour}:${localTimeMin}`,
      userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    console.log("selectedPeriodName", selectedPeriodName);
    if (["weekly", "bi-weekly"].includes(selectedPeriodName.toLowerCase())) {
      investment.repeatsOn = selectedDays
        .map((day) => day.toUpperCase())
        .join(",");
    } else if (selectedPeriodName === "Monthly") {
      investment.repeatsOn = dateOfMonth;
    } else {
      investment.repeatsOn = null;
    }
    const investmentAssets = [];
    let sumOfPercentage = 0;
    addAssetList.forEach((asset) => {
      const currencyId = asset.asset;
      const assetAllocation = parseFloat(asset.percent);
      const assetPercentage = parseFloat(assetAllocation || 0);
      sumOfPercentage += assetPercentage;
      investmentAssets.push({
        currencyId,
        assetAllocation,
        id: asset.allocationId || null,
      });
    });
    investment.investmentAssets = investmentAssets;
    console.log("sumOfPercentage", sumOfPercentage);
    if (sumOfPercentage === 100) {
      const payload = { investment };
      console.log("payload", payload);
      try {
        const response = await axios.post(
          `${WEBSERVICE}crypto/banking/portfolio/updatePortfolioInvestment`,
          JSON.stringify(payload),
          {
            headers: {
              "Content-Type": "application/json",
              authorization: "BEARER " + localStorage.getItem("access_token"),
            },
          }
        );
        const result = response.data;
        if (result.error.error_data !== 0) {
          showToast("error", result.error.error_msg);
        } else {
          setPlanNameForCreate("");
          setRecurringAmount("");
          setRecurringAssetId("");
          setLocalTime("");
          setDateOfMonth("");
          setSelectedDays([]);
          setAddAssetList([]);
          setIsOneTimeEnable(false);
          setIsEarnWalletSelected(false);
          setLocalTimeMin("");
          investment.createdOn = new Date().toString();
          showToast("success", result.error.error_msg);
          setOpen(false);
          fetchPlans();
        }
      } catch (error) {
        if ([400, 401, 403].includes(error?.response?.status)) {
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        } else {
          showToast("error", "Could Not Connect To Server");
        }
      }
    } else {
      showToast("error", "Sum of asset allocation percentages must be 100%");
    }
  };

  const getMarketPrice = async () => {
    const payload = {
      currency: homeCurrency,
      baseCurrency: "USD",
      action: 2,
    };
    try {
      const marketPriceResponse = await axios.post(
        `${WEBSERVICE}home/marketPrice`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      setMarketPrice(marketPriceResponse?.data?.marketPrice);
    } catch (err) {
      console.log("error--->", err);
    }
  };

  const renderSkeletonRows = (rowCount = 5) => {
    return [...Array(rowCount)].map((_, i) => (
      <TableRow key={i}>
        {Array.from({ length: 11 }).map((_, j) => (
          <TableCell key={j}>
            <Skeleton variant="text" width="80%" height={20} />
          </TableCell>
        ))}
      </TableRow>
    ));
  };

  const allowNumber = (e) => {
    const key = e.key;
    const value = e.target.value;
    if (
      key === "Backspace" ||
      key === "Tab" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Delete"
    ) {
      return;
    }
    const regex = /^[0-9]$/;
    if (key === ".") {
      if (value.includes(".")) {
        e.preventDefault();
      }
      return;
    }
    if (!regex.test(key)) {
      e.preventDefault();
    }
  };

  const allowOnlyAlphabets = (e) => {
    const key = e.key;
    if (
      key === "Backspace" ||
      key === "Tab" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Delete"
    ) {
      return;
    }
    const regex = /^[a-zA-Z\s]$/;
    if (!regex.test(key)) {
      e.preventDefault();
    }
  };

  const handlePasteOnlyAlpha = (e) => {
    const pasteData = e.clipboardData.getData("text");
    const regex = /^[a-zA-Z\s]$/;
    if (!regex.test(pasteData)) {
      e.preventDefault();
    }
  };

  const allowOnlyAlphaNum = (e) => {
    const key = e.key;
    if (
      key === "Backspace" ||
      key === "Tab" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Delete"
    ) {
      return;
    }
    const regex = /^[a-zA-Z0-9 ]*$/;
    if (!regex.test(key)) {
      e.preventDefault();
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text");
    const regex = /^[a-zA-Z0-9 ]*$/;
    if (!regex.test(pasteData)) {
      e.preventDefault();
    }
  };

  const getCurrency = () => {
    const filterData = portfolioAssetsForBase?.filter(
      (a) => a?.currencyId === invCurrencyId
    );
    return filterData[0]?.currencyCode;
  };

  // ── Table headers ──────────────────────────────────────────────────────────
  const tableHeaders = [
    "Plan Name",
    "Invest Schedule",
    "Subscription",
    `Invested Amount (${homeCurrency})`,
    "Purchased Asset",
    `Avg. Price (${homeCurrency})`,
    "PNL",
    "ROI",
    "Start Date",
    "Next Auto-Invest",
    "Action",
  ];

  const detailHeaders = [
    "Portfolio Asset",
    "Allocation",
    `Invested Amount (in ${getCurrency()})`,
    "Purchased Amount",
    `Average Price (${homeCurrency})`,
    "PNL",
    "ROI",
  ];

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <Box sx={pageWrapper}>

      {/* ── Hero Banner ── */}
      <Box
        sx={{
          ...heroBanner,
          background: `linear-gradient(135deg, ${alpha(
            btncolor || "#1976d2",
            0.95
          )} 0%, ${alpha(btncolor || "#1976d2", 0.72)} 100%)`,
        }}
      >
        {/* Decorative circles */}
        <Box sx={heroDecorCircleLg} />
        <Box sx={heroDecorCircleSm} />

        <Box sx={heroContent}>
          <Box sx={heroIconBadge}>
            <AccountTreeOutlinedIcon sx={{ color: "#fff", fontSize: 28 }} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography sx={heroTitle}>Portfolio Wallet</Typography>
            <Typography sx={heroSubtitle}>
              Track, manage and auto-invest your portfolio plans across assets
            </Typography>
            {/* Info points */}
            <Box sx={heroInfoRow}>
              <Box sx={heroInfoItem}>
                <CheckCircleOutlineIcon sx={{ fontSize: 14, flexShrink: 0 }} />
                <Typography sx={heroInfoText}>
                  Go to the Portfolio module from the grid menu and add assets
                  for investment
                </Typography>
              </Box>
              <Box sx={heroInfoItem}>
                <CheckCircleOutlineIcon sx={{ fontSize: 14, flexShrink: 0 }} />
                <Typography sx={heroInfoText}>
                  Added assets will appear here in your Portfolio Wallet
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* ── Main Card ── */}
      <Box sx={mainCard}>
        {/* Card header */}
        <Box sx={cardHeader}>
          <Box>
            <Typography sx={cardTitle}>Investment Plans</Typography>
            <Typography sx={cardCaption}>
              {portfolioInvestmentPlans.length} plan
              {portfolioInvestmentPlans.length !== 1 ? "s" : ""} found
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ borderColor: "rgba(125,125,125,0.13)" }} />

        {/* ── Table ── */}
        <TableContainer sx={modernTableContainer}>
          <Table sx={tableStyle}>
            <TableHead>
              <TableRow sx={modernTableHeadRow}>
                {tableHeaders.map((h, i) => (
                  <TableCell key={i} sx={modernTableHeadCell}>
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                renderSkeletonRows()
              ) : portfolioInvestmentPlans.length > 0 ? (
                portfolioInvestmentPlans
                  .sort((a, b) => b.planId - a.planId)
                  .map((plan) => (
                    <TableRow key={plan.planId} sx={modernTableBodyRow}>
                      <TableCell sx={modernTableBodyCell}>
                        <Typography sx={planNameText}>{plan.planName}</Typography>
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {plan.portfolioInvestmentSchedule}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        <Switch
                          checked={Boolean(plan.isSubscription)}
                          onChange={(e) =>
                            updateAutoSubscribe(plan, e.target.checked)
                          }
                          sx={{
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: btncolor,
                            },
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                              { backgroundColor: btncolor },
                          }}
                        />
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {homeCurrencySymbol} {plan.totalInvestmentAmount}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        <Tooltip title="Click to view investments">
                          <Typography
                            sx={{
                              ...showInvestmentsLink,
                              color: btncolor,
                            }}
                            onClick={() => (
                              getShowDetailsCurrency(plan.planId),
                              handleShowInvestment(plan.planId)
                            )}
                          >
                            Show investments
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {homeCurrencySymbol}
                        {parseFloat(plan.averagePriceUsd.replace(/,/g, ""))}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                          {plan.profitAndLoss >= 0 ? (
                            <TrendingUpIcon sx={{ fontSize: 14, color: "#16a34a" }} />
                          ) : (
                            <TrendingDownIcon sx={{ fontSize: 14, color: "#ef4444" }} />
                          )}
                          <Typography
                            sx={{
                              fontSize: "0.85rem",
                              fontWeight: 600,
                              color:
                                plan.profitAndLoss >= 0 ? "#16a34a" : "#ef4444",
                            }}
                          >
                            {homeCurrencySymbol}
                            {Number(plan.profitAndLoss).toFixed(2)}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        <Typography
                          sx={{
                            fontSize: "0.85rem",
                            fontWeight: 600,
                            color:
                              plan.returnOnInvestment >= 0
                                ? "#16a34a"
                                : "#ef4444",
                          }}
                        >
                          {Number(plan.returnOnInvestment).toFixed(2)}%
                        </Typography>
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {plan.planStartDate}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {plan.isSubscription === 1
                          ? plan.nextAutoInvestmentDate
                          : "—"}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        <Stack direction="row" spacing={0.5}>
                          <Tooltip title="Edit Plan">
                            <IconButton
                              onClick={() => getSpecificPlanDetails(plan.planId)}
                              size="small"
                              sx={{ color: btncolor }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete Plan">
                            <IconButton
                              onClick={() => openRemoveDialog(plan.planId)}
                              size="small"
                              sx={{ color: "#ef4444" }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={tableHeaders.length} sx={emptyCell}>
                    <InboxOutlinedIcon sx={emptyIcon} />
                    <Typography sx={emptyText}>
                      You have not added assets from the Portfolio Invest module
                      yet. Added assets will be visible in your Portfolio Wallet.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* ── Portfolio Assets Dialog ── */}
      <Dialog
        open={showModal}
        onClose={handleCloseModal}
        maxWidth="lg"
        fullWidth
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          Portfolio Assets
          <IconButton
            onClick={handleCloseModal}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogContent sx={dialogContentStyle}>
          <TableContainer sx={modernTableContainer}>
            <Table size="small" sx={tableStyle}>
              <TableHead>
                <TableRow sx={modernTableHeadRow}>
                  {detailHeaders.map((label, index) => (
                    <TableCell key={index} sx={modernTableHeadCell}>
                      {label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {investedAssetList.length > 0 ? (
                  investedAssetList.map((asset, i) => (
                    <TableRow key={i} sx={modernTableBodyRow}>
                      <TableCell sx={modernTableBodyCell}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Avatar
                            src={`https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/${asset.portfolioAsset}.png`}
                            alt={asset.portfolioAsset}
                            sx={{ width: 24, height: 24 }}
                          />
                          <Typography sx={{ fontSize: "0.85rem", fontWeight: 600, color: "var(--text-color)" }}>
                            {asset.portfolioAsset}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {asset.allocation}%
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {currencySymbols[getCurrency()]} {asset.investedUsdAmount}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {asset.purchasedAssetAmount}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {homeCurrencySymbol} {asset.averageUsdPrice}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {asset.profitAndLoss}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {asset.returnOnInvestment}%
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} sx={emptyCell}>
                      <InboxOutlinedIcon sx={emptyIcon} />
                      <Typography sx={emptyText}>No assets found</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>

      {/* ── Remove Plan Dialog ── */}
      <Dialog
        open={isRemoveDialogOpen}
        onClose={() => setIsRemoveDialogOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          Remove Plan
          <IconButton
            onClick={() => setIsRemoveDialogOpen(false)}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogContent sx={{ ...dialogContentStyle, textAlign: "center", pt: 4 }}>
          <WarningAmberIcon sx={{ fontSize: 52, color: "#f59e0b", mb: 2 }} />
          <Typography sx={{ fontSize: "1rem", fontWeight: 600, color: "var(--text-color)", mb: 0.5 }}>
            Remove this plan?
          </Typography>
          <Typography sx={{ fontSize: "0.85rem", color: "var(--text-color)", opacity: 0.6 }}>
            This action cannot be undone.
          </Typography>
        </DialogContent>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogActions sx={{ p: 2.5, gap: 1, justifyContent: "center", backgroundColor: "var(--popupbody-color)" }}>
          <ContainedButton
            variant="contained"
            sx={{ ...dialogActionBtn, backgroundColor: "#ef4444", "&:hover": { backgroundColor: "#dc2626" } }}
            onClick={() => removePlan()}
          >
            Remove
          </ContainedButton>
          <OutlinedButton
            variant="outlined"
            sx={dialogOutlineBtn}
            onClick={() => setIsRemoveDialogOpen(false)}
          >
            Keep it
          </OutlinedButton>
        </DialogActions>
      </Dialog>

      {/* ── Edit / Update Dialog ── */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          Update Investment Portfolio
          <IconButton
            onClick={() => setOpen(false)}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />

        <DialogContent sx={dialogContentStyle}>

          {/* Plan Name */}
          <Box sx={formSection}>
            <Typography sx={formSectionLabel}>Plan Name</Typography>
            <TextField
              fullWidth
              value={planNameForCreate}
              onChange={(e) => setPlanNameForCreate(e.target.value)}
              variant="outlined"
              onKeyDown={allowOnlyAlphabets}
              onPaste={handlePasteOnlyAlpha}
              sx={dialogTextField}
            />
          </Box>

          <Divider sx={{ borderColor: "rgba(125,125,125,0.12)", my: 2 }} />

          {/* Asset Allocation */}
          <Box sx={formSection}>
            <Typography sx={formSectionLabel}>Asset Allocation</Typography>
            <TableContainer sx={{ ...modernTableContainer, mt: 1 }}>
              <Table size="small" sx={tableStyle}>
                <TableBody>
                  {addAssetList.map((asset, index) => (
                    <TableRow key={index} sx={modernTableBodyRow}>
                      <TableCell sx={{ ...modernTableBodyCell, width: isMobile ? "100%" : "40%" }}>
                        <Select
                          fullWidth
                          value={asset.asset}
                          onChange={(e) =>
                            handleAssetChange(index, "asset", e.target.value)
                          }
                          sx={dialogSelectStyle}
                          size="small"
                        >
                          <MenuItem value="">Select Asset</MenuItem>
                          {portfolioAssetsForCounter.map((a) => (
                            <MenuItem key={a.currencyId} value={a.currencyId}>
                              {a.currencyCode}
                            </MenuItem>
                          ))}
                        </Select>
                      </TableCell>
                      <TableCell sx={{ ...modernTableBodyCell, width: isMobile ? "100%" : "50%" }}>
                        <TextField
                          type="number"
                          inputProps={{ min: 0, step: 1 }}
                          value={asset.percent}
                          onChange={(e) =>
                            handleAssetChange(index, "percent", e.target.value)
                          }
                          fullWidth
                          onKeyDown={allowNumber}
                          size="small"
                          sx={dialogTextField}
                        />
                      </TableCell>
                      <TableCell sx={{ ...modernTableBodyCell, width: isMobile ? "100%" : "10%" }}>
                        <OutlinedButton variant="outlined" disabled size="small">
                          Remove
                        </OutlinedButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Typography
              sx={{
                fontSize: "0.82rem",
                mt: 1,
                fontWeight: 600,
                color: currentSumOfAllocation > 100 ? "#ef4444" : currentSumOfAllocation === 100 ? "#16a34a" : "var(--text-color)",
              }}
            >
              Allocation total: {currentSumOfAllocation}%
              {currentSumOfAllocation !== 100 && " (must add up to 100%)"}
            </Typography>
          </Box>

          <Divider sx={{ borderColor: "rgba(125,125,125,0.12)", my: 2 }} />

          {/* Recurring Amount */}
          <Box sx={formSection}>
            <Typography sx={formSectionLabel}>Amount Per Recurring Period</Typography>
            <Box sx={{ display: "flex", gap: 2, mt: 1, flexWrap: "wrap" }}>
              <TextField
                label="Recurring Amount"
                fullWidth
                value={recurringAmount}
                onChange={(e) => setRecurringAmount(e.target.value)}
                onKeyDown={allowNumber}
                size="small"
                sx={{ ...dialogTextField, flex: 1, minWidth: 140 }}
              />
              <FormControl sx={{ flex: 1, minWidth: 140 }} size="small">
                <InputLabel sx={{ color: "var(--text-color)", opacity: 0.6 }}>
                  Select Asset
                </InputLabel>
                <Select
                  label="Select Asset"
                  value={recurringAssetId}
                  onChange={(e) => {
                    setRecurringAssetId(e.target.value);
                    getWalletBalance(e.target.value);
                  }}
                  sx={dialogSelectStyle}
                >
                  <MenuItem value="">Select Asset</MenuItem>
                  {portfolioAssetsForBase.map((a) => (
                    <MenuItem key={a.currencyId} value={a.currencyId}>
                      {a.currencyCode}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            {!(
              Number(recurringAmount) < Number(spotWalletBalance) ||
              Number(recurringAmount) < Number(earnWalletBalance)
            ) && (
              <Typography sx={{ fontSize: "0.82rem", color: "#ef4444", mt: 0.75 }}>
                Insufficient balance
              </Typography>
            )}
          </Box>

          <Divider sx={{ borderColor: "rgba(125,125,125,0.12)", my: 2 }} />

          {/* Wallet Selection */}
          <Box sx={formSection}>
            <Typography sx={formSectionLabel}>Wallet Selection</Typography>
            <TableContainer sx={{ ...modernTableContainer, mt: 1 }}>
              <Table size="small" sx={tableStyle}>
                <TableBody>
                  <TableRow sx={modernTableBodyRow}>
                    <TableCell sx={modernTableBodyCell}>Spot Wallet</TableCell>
                    <TableCell sx={modernTableBodyCell}>{spotWalletBalance}</TableCell>
                    <TableCell sx={{ ...modernTableBodyCell, color: "var(--text-color)", opacity: 0.5, fontSize: "0.75rem" }}>
                      Default
                    </TableCell>
                  </TableRow>
                  <TableRow sx={modernTableBodyRow}>
                    <TableCell sx={modernTableBodyCell}>Earn Interest Wallet</TableCell>
                    <TableCell sx={modernTableBodyCell}>{earnWalletBalance}</TableCell>
                    <TableCell sx={modernTableBodyCell}>
                      <Checkbox
                        checked={isEarnWalletSelected}
                        onChange={toggleWallet}
                        sx={{
                          color: "var(--text-color)",
                          "&.Mui-checked": { color: btncolor },
                          p: 0,
                        }}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Divider sx={{ borderColor: "rgba(125,125,125,0.12)", my: 2 }} />

          {/* Recurring Period */}
          <Box sx={formSection}>
            <Typography sx={formSectionLabel}>Recurring Period</Typography>
            <FormControlLabel
              control={
                <Switch
                  checked={isOneTimeEnable}
                  onChange={() => setIsOneTimeEnable(!isOneTimeEnable)}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": { color: btncolor },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: btncolor,
                    },
                  }}
                />
              }
              label={
                <Typography sx={{ fontSize: "0.85rem", color: "var(--text-color)" }}>
                  One-time
                </Typography>
              }
              sx={{ mt: 1 }}
            />

            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1.5 }}>
              {recurringPeriodsOther.map((period) => (
                <Button
                  key={period.id}
                  variant={
                    selectedRecurringPeriodId === period.id
                      ? "contained"
                      : "outlined"
                  }
                  size="small"
                  sx={{
                    ...periodBtn,
                    backgroundColor:
                      selectedRecurringPeriodId === period.id
                        ? btncolor
                        : "transparent",
                    borderColor:
                      selectedRecurringPeriodId !== period.id
                        ? alpha(btncolor || "#1976d2", 0.5)
                        : btncolor,
                    color: "var(--text-color)",
                  }}
                  disabled
                >
                  {period.name}
                </Button>
              ))}
            </Box>

            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
              {recurringPeriodsHours.map((period) => (
                <Button
                  key={period.id}
                  variant={
                    selectedRecurringPeriodId === period.id
                      ? "contained"
                      : "outlined"
                  }
                  size="small"
                  sx={{
                    ...periodBtn,
                    backgroundColor:
                      selectedRecurringPeriodId === period.id
                        ? btncolor
                        : "transparent",
                    borderColor:
                      selectedRecurringPeriodId !== period.id
                        ? alpha(btncolor || "#1976d2", 0.5)
                        : btncolor,
                    color: "var(--text-color)",
                  }}
                  disabled
                >
                  {period.name}
                </Button>
              ))}
            </Box>

            {["Weekly", "Bi-weekly"].includes(selectedRecurringPeriodName) && (
              <Box sx={{ mt: 2 }}>
                <Typography sx={{ ...formSectionLabel, mb: 1 }}>Repeats On</Typography>
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  {daysOfWeeks.map((day) => (
                    <Button
                      key={day}
                      variant={
                        selectedDays.includes(day) ? "contained" : "outlined"
                      }
                      size="small"
                      sx={{
                        ...periodBtn,
                        backgroundColor: selectedDays.includes(day)
                          ? btncolor
                          : "transparent",
                        borderColor: !selectedDays.includes(day)
                          ? alpha(btncolor || "#1976d2", 0.5)
                          : btncolor,
                        color: "var(--text-color)",
                      }}
                      onClick={() => selectDaysForPortfolio(day)}
                    >
                      {day}
                    </Button>
                  ))}
                </Box>
              </Box>
            )}

            {selectedRecurringPeriodName === "Monthly" && (
              <Box sx={{ mt: 2 }}>
                <TextField
                  label="Day of Month (1–31)"
                  type="number"
                  value={dateOfMonth}
                  size="small"
                  onChange={(e) => {
                    let val = e.target.value;
                    if (val.length > 2) return;
                    if (val.startsWith("0") && val.length > 1) {
                      val = val.replace(/^0+/, "");
                    }
                    if (val === "" || (Number(val) >= 1 && Number(val) <= 31)) {
                      setDateOfMonth(val);
                    }
                  }}
                  inputProps={{ maxLength: 2 }}
                  sx={dialogTextField}
                />
              </Box>
            )}

            <Box sx={{ display: "flex", gap: 1.5, mt: 2, alignItems: "center" }}>
              <TextField
                type="number"
                label="HH"
                value={localTimeHour}
                size="small"
                sx={{ ...dialogTextField, width: 90 }}
                onChange={(e) => {
                  let val = e.target.value;
                  if (val === "") { setLocalTimeHour(""); return; }
                  if (val.length > 2) return;
                  const num = Number(val);
                  if (num >= 0 && num <= 23) setLocalTimeHour(val);
                }}
                inputProps={{ min: 0, max: 24, maxLength: 2 }}
              />
              <Typography sx={{ color: "var(--text-color)", opacity: 0.5, fontWeight: 700 }}>
                :
              </Typography>
              <TextField
                type="number"
                label="MM"
                value={localTimeMin}
                size="small"
                sx={{ ...dialogTextField, width: 90 }}
                onChange={(e) => {
                  let val = e.target.value;
                  if (val === "") { setLocalTimeMin(""); return; }
                  if (val.length > 2) return;
                  const num = Number(val);
                  if (num >= 0 && num <= 59) setLocalTimeMin(val);
                }}
                inputProps={{ min: 0, max: 59, maxLength: 2 }}
              />
            </Box>
            {firstCycleMessage && (
              <Typography sx={{ fontSize: "0.78rem", color: "var(--text-color)", opacity: 0.55, mt: 1 }}>
                {firstCycleMessage}
              </Typography>
            )}
          </Box>
        </DialogContent>

        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogActions sx={{ p: 2.5, gap: 1, justifyContent: "center", backgroundColor: "var(--popupbody-color)" }}>
          <OutlinedButton
            variant="outlined"
            sx={dialogOutlineBtn}
            onClick={() => setOpen(false)}
          >
            Cancel
          </OutlinedButton>
          <ContainedButton
            variant="contained"
            disabled={
              !(
                Number(recurringAmount) < Number(spotWalletBalance) ||
                Number(recurringAmount) < Number(earnWalletBalance)
              )
            }
            sx={{ ...dialogActionBtn, minWidth: 140 }}
            onClick={() => clickToUpdate()}
          >
            Invest Now
          </ContainedButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

// ── Styles ─────────────────────────────────────────────────────────────────────

const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

// Hero
const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroDecorCircleLg = {
  position: "absolute",
  width: 380,
  height: 380,
  borderRadius: "50%",
  backgroundColor: "rgba(255,255,255,0.06)",
  right: -80,
  top: -100,
  pointerEvents: "none",
};

const heroDecorCircleSm = {
  position: "absolute",
  width: 180,
  height: 180,
  borderRadius: "50%",
  backgroundColor: "rgba(255,255,255,0.05)",
  left: -40,
  bottom: -50,
  pointerEvents: "none",
};

const heroContent = {
  display: "flex",
  alignItems: "flex-start",
  gap: 2,
  position: "relative",
  zIndex: 1,
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
  mt: 0.25,
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  mb: 1.5,
  maxWidth: 560,
};

const heroInfoRow = {
  display: "flex",
  flexDirection: "column",
  gap: 0.75,
};

const heroInfoItem = {
  display: "flex",
  alignItems: "flex-start",
  gap: 0.75,
  color: "rgba(255,255,255,0.88)",
};

const heroInfoText = {
  fontSize: "0.8rem",
  color: "rgba(255,255,255,0.85)",
  lineHeight: 1.5,
};

// Main card
const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const cardHeader = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  px: { xs: 2, md: 3 },
  py: 2,
  backgroundColor: "var(--body-color-less2)",
};

const cardTitle = {
  fontSize: "1rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
};

const cardCaption = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.55,
  mt: 0.25,
};

// Table
const modernTableContainer = {
  borderRadius: 0,
  boxShadow: "none",
  overflowX: "auto",
  backgroundColor: "var(--body-color-less)",
};

const tableStyle = {
  minWidth: 900,
};

const modernTableHeadRow = {
  backgroundColor: "var(--body-color-less2)",
};

const modernTableHeadCell = {
  fontWeight: 700,
  fontSize: "0.72rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.75,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  py: 1.75,
  whiteSpace: "nowrap",
};

const modernTableBodyRow = {
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "var(--body-color-less2)" },
  "&:last-child td": { borderBottom: 0 },
};

const modernTableBodyCell = {
  fontSize: "0.85rem",
  py: 1.5,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
  color: "var(--text-color)",
  whiteSpace: "nowrap",
};

const planNameText = {
  fontSize: "0.85rem",
  fontWeight: 600,
  color: "var(--text-color)",
};

const showInvestmentsLink = {
  fontSize: "0.82rem",
  fontWeight: 600,
  cursor: "pointer",
  textDecoration: "underline",
  textUnderlineOffset: "3px",
  display: "inline",
};

const emptyCell = {
  textAlign: "center",
  py: 7,
  borderBottom: 0,
};

const emptyIcon = {
  fontSize: 48,
  color: "var(--text-color)",
  opacity: 0.35,
  mb: 1,
};

const emptyText = {
  fontSize: "0.9rem",
  color: "var(--text-color)",
  opacity: 0.6,
  maxWidth: 420,
  mx: "auto",
};

// Dialogs
const dialogPaper = {
  borderRadius: "16px",
  minWidth: { xs: "90%", sm: 440 },
  boxShadow: "0 24px 60px rgba(0,0,0,0.28)",
  overflow: "hidden",
  backgroundColor: "var(--popupbody-color)",
  color: "var(--text-color)",
};

const dialogTitleStyle = {
  textAlign: "center",
  fontWeight: 700,
  fontSize: "1.05rem",
  py: 2,
  color: "var(--text-color)",
  backgroundColor: "var(--popupheader-color)",
  position: "relative",
};

const dialogCloseBtn = {
  position: "absolute",
  right: 12,
  top: "50%",
  transform: "translateY(-50%)",
  color: "var(--text-color)",
  opacity: 0.6,
};

const dialogContentStyle = {
  backgroundColor: "var(--popupbody-color)",
  py: 2.5,
  px: { xs: 2, md: 3 },
};

const dialogTextField = {
  "& .MuiInputBase-root": {
    borderRadius: "10px",
    backgroundColor: "var(--body-color-less2)",
    color: "var(--text-color)",
    fontSize: "0.88rem",
  },
  "& .MuiInputBase-input": { color: "var(--text-color)" },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.25)",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.45)",
  },
  "& .MuiInputLabel-root": { color: "var(--text-color)", opacity: 0.6 },
  "& .MuiSelect-select": { color: "var(--text-color)" },
  "& .MuiSvgIcon-root": { color: "var(--text-color)", opacity: 0.7 },
};

const dialogSelectStyle = {
  borderRadius: "10px",
  backgroundColor: "var(--body-color-less2)",
  color: "var(--text-color)",
  fontSize: "0.88rem",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.25)",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.45)",
  },
  "& .MuiSelect-select": { color: "var(--text-color)" },
  "& .MuiSvgIcon-root": { color: "var(--text-color)", opacity: 0.7 },
};

const formSection = {};

const formSectionLabel = {
  fontSize: "0.72rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.55,
  mb: 0.75,
};

const periodBtn = {
  fontSize: "0.75rem",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "8px",
  height: 32,
  minWidth: 56,
};

const dialogActionBtn = {
  height: 44,
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.88rem",
  px: 3,
};

const dialogOutlineBtn = {
  height: 44,
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.88rem",
  px: 3,
  borderColor: "rgba(125,125,125,0.35)",
  color: "var(--text-color)",
};

export default PortfolioWallet;
